module.exports = __webpack_public_path__ + "img/mercedes-eqc-page-gal-3.4bd3f213.jpg";